/* Adventskalender 2026 „Inner Universe" — Bewegung, Slider, Zähler.
   Portiert aus dem A+ Content, Klassen auf advk- umgestellt. */
(function () {
  'use strict';
  var root = document.querySelector('.advk-2026');
  if (!root) return;                       // Section nicht auf der Seite
  if (window.__advk2026) return;            // idempotent, Section kann 2x laden
  window.__advk2026 = true;

  var rm = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var navFixed = false;

  /* Wie weit ein Bild in seinem Rahmen wandert, waehrend die Bahn gleitet.
     Gehoert mit der Bildbreite im CSS zusammen (.advk-sh img und
     .advk-lb-rahmen img stehen auf 112 %): der Ueberstand von 12 % ist der
     Weg, den dieser Wert ausnutzt. Wer eines von beiden aendert, muss das
     andere mitziehen — sonst laeuft das Bild ueber den Rahmen hinaus oder
     der Effekt verpufft. */
  var UEBERSTAND = 34;

  /* --- A+ Bilder erst nach dem Wichtigen ------------------------------ */
  /* loading="lazy" haelt weniger zurueck, als der Name verspricht: der
     Browser laedt grosszuegig vor, im Test kamen zwei von drei Bildern sofort.
     Auf einer Produktseite konkurriert das mit Bildern und Skripten des
     Kaufmoduls. Darum tragen die A+ Bilder ihre Quelle zunaechst nur in
     data-advk-src; eingesetzt wird sie, wenn die Seite fertig geladen hat —
     und je Bild erst, wenn es in die Naehe des Blickfelds kommt.
     Ohne JS greift der <noscript>-Zweig im Markup, es bleibt also nichts leer. */
  function aplusBilder() {
    var offen = document.querySelectorAll('img[data-advk-src]');
    if (!offen.length) return;

    /* Der Vorlauf richtet sich nach der Fensterhoehe, nicht nach einer festen
       Zahl. 400 px waren am Handy fast ein ganzer Schirm, an einem hohen
       Desktop-Fenster aber weniger als ein halber — die Bilder bekamen ihre
       Quelle erst ~300 px unter der Kante und luden sichtbar nach, waehrend
       man schon davorstand. Anderthalb Fensterhoehen geben auf jedem Geraet
       denselben Vorsprung, ohne gleich die ganze Seite zu holen. */
    var vorlauf = Math.round(Math.max(600, innerHeight * 1.5));

    function einsetzen(b) {
      if (!b.dataset.advkSrc) return;
      if (b.dataset.advkSrcset) b.srcset = b.dataset.advkSrcset;
      b.src = b.dataset.advkSrc;
      b.removeAttribute('data-advk-src');
      b.removeAttribute('data-advk-srcset');
    }

    /* Zwei Zonen. Was im Blickfeld steht (oder gleich daneben), wird sofort
       geholt — darauf wartet jemand. Was weiter unten liegt, haelt bis zum
       load-Ereignis still, damit der A+ Content dem Kaufmodul keine Bandbreite
       nimmt. Frueher hing ALLES am load-Ereignis; auf einer Produktseite kommt
       das spaet (viele Bilder, App-Skripte), und wer sofort scrollte, stand vor
       einem leeren Feld, dessen Bild noch nicht einmal angefordert war. */
    var wartend = [];
    var frei = document.readyState === 'complete';

    function istImBlick(b) {
      var r = b.getBoundingClientRect();
      /* Ein halber Schirm Zugabe: was so nah steht, sieht man gleich.
         Waagerecht zaehlt mit, sonst gaelte eine Galeriekachel weit rechts
         als "im Blick", nur weil sie auf der richtigen Hoehe liegt. */
      return r.top < innerHeight * 1.5 && r.bottom > -innerHeight * 0.5 &&
             r.left < innerWidth * 1.5 && r.right > -innerWidth * 0.5;
    }

    function beimSehen(es, o) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var b = e.target;
        o.unobserve(b);
        if (frei || istImBlick(b)) einsetzen(b);
        else wartend.push(b);
      });
    }

    /* Zwei Beobachter, weil es zwei Arten von Bewegung gibt. Der normale
       schaut auf das Fenster und deckt alles ab, was beim Runterscrollen
       naeher kommt. Bilder in einer waagerechten Bahn — die Galerie — bewegen
       sich aber INNERHALB ihres Kastens: fuer das Fenster stehen sie still,
       weit rechts ausserhalb. Von 25 Kacheln bekamen so nur die ersten drei
       eine Quelle, die anderen 22 warteten ewig und zeigten dauerhaft den
       Schimmer. Sie brauchen einen Beobachter, dessen Bezug die Bahn selbst
       ist, mit Vorlauf zur Seite statt nach unten. */
    var fensterBeob = new IntersectionObserver(function (es) {
      beimSehen(es, fensterBeob);
    }, { rootMargin: vorlauf + 'px 0px' });

    var bahnBeob = new Map();

    offen.forEach(function (b) {
      var bahn = b.closest('.advk-track, .advk-lb-track, .advk-gal');
      if (!bahn) { fensterBeob.observe(b); return; }

      var o = bahnBeob.get(bahn);
      if (!o) {
        /* Eine Bahnbreite Vorlauf: die naechsten Kacheln stehen bereit,
           bevor man sie heranwischt. */
        o = new IntersectionObserver(function (es) {
          beimSehen(es, o);
        }, { root: bahn, rootMargin: '0px ' + Math.round(bahn.clientWidth || 600) + 'px' });
        bahnBeob.set(bahn, o);
      }
      o.observe(b);
    });

    if (!frei) {
      addEventListener('load', function () {
        frei = true;
        wartend.forEach(einsetzen);
        wartend.length = 0;
      }, { once: true });

      /* Scrollt jemand vor dem load-Ereignis weiter, darf das Wartende nicht
         liegenbleiben: was dabei in den Blick geraet, wird sofort geholt.
         Ein Frame Sammelpause wie bei den anderen Scroll-Hoerern der Datei —
         sonst misst jedes einzelne Scroll-Ereignis die ganze Warteschlange
         durch, und das ausgerechnet waehrend die Seite noch laedt. */
      var pTick = false;
      var pruefen = function () {
        if (pTick || !wartend.length) return;
        pTick = true;
        requestAnimationFrame(function () {
          wartend = wartend.filter(function (b) {
            if (!istImBlick(b)) return true;
            einsetzen(b);
            return false;
          });
          pTick = false;
        });
      };
      addEventListener('scroll', pruefen, { passive: true });
      addEventListener('load', function () {
        removeEventListener('scroll', pruefen);
      }, { once: true });
    }
  }

  aplusBilder();

  /* --- Ladeschimmer --------------------------------------------------- */
  /* Der reservierte Platz bleibt waehrend des Ladens nicht leer, sondern
     zeigt einen goldenen Schimmer. Die Huelle bekommt ihn per Skript
     eingesetzt — im Markup stuende sonst ohne JS ein Kasten, der nie
     verschwindet. */
  /* Welche Huellen einen Schimmer bekommen, entscheidet das Markup: wer
     data-advk-schimmer traegt, ist dabei. Die beiden Klassen stehen aus
     Bestandsgruenden weiter in der Liste — neue Stellen brauchen aber keine
     Aenderung mehr an dieser Datei. */
  (function schimmer() {
    var stellen = document.querySelectorAll(
      '[data-advk-schimmer], .advk-ch-media, .advk-sh');
    stellen.forEach(function (huelle) {
      var bild = huelle.querySelector('img');
      if (!bild) return;

      /* Schon im Cache? Dann gar nicht erst flackern lassen. Ein Bild, das
         seine Quelle noch aussteht (data-advk-src), gilt nicht als fertig —
         complete ist ohne src ebenfalls true und haette den Schimmer sofort
         wieder abgeraeumt. */
      if (!bild.hasAttribute('data-advk-src') && bild.complete && bild.naturalWidth > 0) {
        huelle.classList.add('advk-geladen');
        return;
      }

      var s = document.createElement('span');
      s.className = 'advk-shimmer';
      s.setAttribute('aria-hidden', 'true');
      huelle.insertBefore(s, huelle.firstChild);
      huelle.classList.add('advk-laedt');

      function fertig() {
        huelle.classList.remove('advk-laedt');
        huelle.classList.add('advk-geladen');
      }
      bild.addEventListener('load', fertig, { once: true });
      /* Auch bei Fehlern aufloesen: ein Schimmer, der ewig laeuft, sieht aus
         wie eine haengende Seite. */
      bild.addEventListener('error', fertig, { once: true });
    });
  })();

  /* --- Reveal ------------------------------------------------------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('advk-in'); io.unobserve(e.target); }
    });
  /* Ebenfalls mit Vorlauf statt mit verkleinertem Rand: die Einblendung soll
     durch sein, wenn man ankommt, nicht erst dann beginnen. */
  }, { threshold: 0, rootMargin: '0px 0px ' + Math.round(innerHeight * 0.25) + 'px 0px' });
  document.querySelectorAll('.advk-reveal,.advk-bar,.advk-story,.advk-value')
    .forEach(function (n) { io.observe(n); });

  /* --- Bild-Wipe ---------------------------------------------------- */
  /* WICHTIG: der Observer hängt am ELTERNELEMENT. Ein per clip-path
     vollständig abgeschnittenes Element meldet Chrome nie als intersecting.
     Nicht "vereinfachen". */
  document.querySelectorAll('.advk-reveal-clip').forEach(function (n) {
    var t = n.parentElement || n;
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { n.classList.add('advk-in'); o.disconnect(); } });
    /* Schon aufdecken, BEVOR die Spalte im Bild ist: eine halbe Fensterhoehe
       Vorlauf, damit das Motiv steht, wenn man ankommt.
       Vorher mussten 12 % sichtbar sein UND der untere Rand war um 6 %
       verkleinert — bei einem 911 px hohen Kapitel also rund 163 px. Wer knapp
       darueber stehenblieb, sah dunkles Nichts, obwohl das Bild laengst
       geladen war: der Rahmen blieb per clip-path auf Hoehe null. */
    }, { threshold: 0, rootMargin: '0px 0px ' + Math.round(innerHeight * 0.5) + 'px 0px' });
    o.observe(t);
  });

  /* --- Zahlen zählen hoch ------------------------------------------- */
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, to = parseInt(el.dataset.count, 10), t0 = null;
      if (rm || isNaN(to)) { el.textContent = isNaN(to) ? el.textContent : to; return; }
      requestAnimationFrame(function step(t) {
        t0 = t0 || t;
        var p = Math.min((t - t0) / 1100, 1);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      });
    });
  }, { threshold: .6 });
  document.querySelectorAll('[data-count]').forEach(function (n) { cio.observe(n); });

  /* --- Fortschritt, Sticky-Leiste, aktive Sprungmarke --------------- */
  var prog   = document.querySelector('.advk-progress'),
      sticky = document.querySelector('.advk-sticky'),
      /* KORREKTUR gegenüber Entwurf: der Entwurf misst gegen #story.
         Auf der echten PDP liegt darüber das Kaufmodul — sonst fährt die
         Leiste zu früh ein. Wir messen gegen das Ende der main-Section.
         ACHTUNG: heideman-main-product.liquid rendert
         id="MainProduct-{{ section.id }}", es gibt KEIN Element mit der
         id "MainProduct". Darum Präfix-Selektor, nicht getElementById. */
      gate   = document.querySelector('[id^="MainProduct-"]')
               || document.querySelector('.advk-story'),
      navbar = document.querySelector('.advk-nav'),
      navWrap = navbar ? navbar.parentElement : null,
      links  = [].slice.call(document.querySelectorAll('[data-advk-nav] a')),
      secs   = links.map(function (a) {
                 var h = a.getAttribute('href') || '';
                 return h.charAt(0) === '#' ? document.querySelector(h) : null;
               }),
      tick = false;

  function onScroll() {
    var h = document.documentElement, y = h.scrollTop,
        max = h.scrollHeight - h.clientHeight;
    if (prog) prog.style.width = (max ? y / max * 100 : 0) + '%';
    if (sticky && gate) {
      sticky.classList.toggle('advk-on', y > gate.offsetTop + gate.offsetHeight * 0.65);
    }
    /* Die Sprungleiste wird erst fixiert, wenn man an ihrem eigenen Platz
       vorbeigescrollt ist — nicht schon vorher, sonst schwebt sie über Inhalt,
       den sie noch gar nicht passiert hat. Gemessen wird gegen den Wrapper, weil
       die Leiste im fixierten Zustand aus dem Fluss ist und ihre eigene Position
       dann nichts mehr aussagt. */
    if (navbar && navWrap) {
      /* Schaltpunkt ist die Stelle, an der der Platzhalter oben aus dem Bild
         läuft. Die Hysterese ist bewusst klein (2 px): sie reicht gegen das
         Zittern bei Subpixel-Scrollwerten, erzeugt aber keinen sichtbaren
         Versatz. Mit den vorherigen 40 px hielt die Leiste beim Hochscrollen
         zu lange fest und sprang dann 42 px auf einmal nach unten — bergab
         war der Übergang gleitend, bergauf nicht. */
      /* Ein einziger Schaltpunkt, keine Hysterese: sobald der Platzhalter die
         Oberkante erreicht, übernimmt die fixierte Leiste — in beide Richtungen
         an genau derselben Stelle. Jede Hysterese erzeugt bergauf einen
         sichtbaren Versatz in ihrer Höhe (bei 40 px waren es 42 px, bei 6 px
         noch 7 px). Ein Flattern ist hier nicht möglich, weil beide Zustände
         denselben Kasten belegen: die Klasse wechselt, das Bild nicht. */
      var platz = navWrap.getBoundingClientRect().top;
      var fixieren = platz <= 0;
      if (fixieren !== navFixed) {
        navFixed = fixieren;
        navbar.classList.toggle('advk-on', fixieren);
        document.documentElement.classList.toggle('advk-nav-uebernimmt', fixieren);
      }
    }
    var mid = y + h.clientHeight * 0.35, cur = -1;
    secs.forEach(function (s, i) { if (s && s.offsetTop <= mid) cur = i; });
    links.forEach(function (a, i) { a.classList.toggle('advk-on', i === cur); });
    if (!rm) {
      document.querySelectorAll('.advk-parallax').forEach(function (im) {
        var r = im.getBoundingClientRect();
        if (r.bottom < 0 || r.top > h.clientHeight) return;
        var off = (r.top + r.height / 2 - h.clientHeight / 2) * (parseFloat(im.dataset.speed) || .12);
        im.style.transform = 'translate3d(0,' + (-off).toFixed(1) + 'px,0) scale(1.14)';
      });
    }
    tick = false;
  }
  addEventListener('scroll', function () {
    if (!tick) { tick = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* --- Galerie-Slider ---------------------------------------------- */
  var track = document.querySelector('.advk-track');
  if (track) {
    /* Auf dem Desktop sind am Anfang zwei Kacheln vollständig sichtbar. Der erste
       Klick soll deshalb nur die zweite hervorheben, ohne die Bahn zu bewegen —
       geschoben wird erst ab der dritten. Dafür merken wir uns die Auswahl
       ausdrücklich, statt sie nur aus der Scrollposition abzuleiten. */
    var wahl = 0, wahlAktiv = false;
    var slides = [].slice.call(track.querySelectorAll('.advk-slide')),
        /* Die Breite gehoert auf die FUELLUNG, nicht auf die Leiste selbst:
           die Leiste ist ein Flex-Kind mit flex:1, ein width darauf blieb
           wirkungslos — es sah aus, als taete die Anzeige nichts. */
        sprog  = document.querySelector('.advk-sl-prog i'),
        chips  = [].slice.call(document.querySelectorAll('.advk-chip'));

    function paint() {
      var c = track.getBoundingClientRect().left + track.clientWidth / 2,
          best = 0, bd = 1e9,
          max = track.scrollWidth - track.clientWidth,
          /* An den Enden gibt es keine mittige Kachel mehr: ganz links kann Nr. 1
             die Mitte nie erreichen, ganz rechts die letzte nicht. Dort wandert die
             Hervorhebung deshalb auf die erste bzw. letzte Kachel. Sonst gilt
             immer die mittigste. */
          amStart = track.scrollLeft <= 2,
          amEnde  = track.scrollLeft >= max - 2;

      slides.forEach(function (sl, i) {
        var r = sl.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - c);
        if (d < bd) { bd = d; best = i; }
        if (!rm) {
          var im = sl.querySelector('img');
          if (im) im.style.transform = 'translate3d(' +
            (((r.left + r.width / 2 - c) / track.clientWidth) * -UEBERSTAND).toFixed(1) + 'px,0,0)';
        }
      });

      if (amStart) best = 0;
      else if (amEnde) best = slides.length - 1;

      /* Solange eine Auswahl per Klick/Taste aktiv ist, behält sie Vorrang —
         sonst würde das Scroll-Neuzeichnen die Hervorhebung sofort zurücksetzen.
         Am rechten Anschlag gewinnt aber die letzte Kachel, damit sie erreichbar
         bleibt. */
      if (wahlAktiv && !amEnde) best = Math.min(slides.length - 1, Math.max(0, wahl));

      slides.forEach(function (sl, i) { sl.classList.toggle('advk-on', i === best); });
      var max = track.scrollWidth - track.clientWidth;
      if (sprog) sprog.style.width =
        Math.max(8, (max ? track.scrollLeft / max * 100 : 0) * 0.88 + 12) + '%';
      var g = slides[best] && slides[best].dataset.g;
      chips.forEach(function (ch) {
        var on = ch.dataset.g === g;
        ch.classList.toggle('advk-on', on);
        ch.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      return best;
    }

    var t2 = false;
    track.addEventListener('scroll', function () {
      if (!t2) { t2 = true; requestAnimationFrame(function () { paint(); t2 = false; }); }
    }, { passive: true });

    function randAbstand() {
      return parseFloat(getComputedStyle(track).paddingLeft) || 0;
    }
    /* Liegt die Kachel schon vollständig im Blickfeld? Direkt gemessen statt
       gerechnet — Kachelbreiten sind prozentual und ändern sich mit dem Fenster,
       eine Formel läuft da leicht auseinander. */
    function ganzSichtbar(i) {
      var tr = track.getBoundingClientRect(),
          r  = slides[i].getBoundingClientRect(),
          pad = randAbstand();
      return r.left >= tr.left + pad - 1 && r.right <= tr.right - pad + 1;
    }
    function go(dir) {
      var w = slides[0].getBoundingClientRect().width + 14,
          max = track.scrollWidth - track.clientWidth;

      /* Erster Schritt aus dem Ruhezustand: die Auswahl wandert innerhalb der
         schon sichtbaren Kacheln, die Bahn bleibt stehen. */
      if (!wahlAktiv) { wahl = paint(); wahlAktiv = true; }
      var ziel = Math.min(slides.length - 1, Math.max(0, wahl + dir));
      wahl = ziel;

      if (ganzSichtbar(ziel)) {        /* schon im Blick -> nur hervorheben */
        markiere(ziel);
        return;
      }
      /* Sonst genau eine Kachelbreite in die gewünschte Richtung schieben, bis
         das Ziel im Blick ist. */
      var neu = track.scrollLeft + dir * w;
      track.scrollTo({ left: Math.min(max, Math.max(0, neu)), behavior: rm ? 'auto' : 'smooth' });
      markiere(ziel);
    }
    function markiere(i) {
      slides.forEach(function (sl, k) { sl.classList.toggle('advk-on', k === i); });
      var g = slides[i] && slides[i].dataset.g, aktiv = null;
      chips.forEach(function (ch) {
        var on = ch.dataset.g === g;
        ch.classList.toggle('advk-on', on);
        ch.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) aktiv = ch;
      });
      /* Auch beim Blaettern mit den Pfeilen soll das hervorgehobene Chip im
         Blick bleiben — sonst leuchtet es ausserhalb des Schirms. */
      if (aktiv) chipInDenBlick(aktiv);
    }
    /* Die Kacheln rasten linksbündig ein, darum wird das Ziel an den linken
       Rand der Bahn gefahren, nicht in die Mitte. */
    function centerOn(i) {
      var r = slides[i].getBoundingClientRect(), tr = track.getBoundingClientRect();
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      track.scrollBy({ left: r.left - tr.left - pad,
                       behavior: rm ? 'auto' : 'smooth' });
    }
    /* Die Chip-Reihe ist breiter als der Schirm. Beim Anklicken wird nicht nur
       das Chip selbst freigestellt, sondern auch sein Nachbar in Laufrichtung —
       sonst blieb das letzte Chip unerreichbar: wer "Feel" waehlt, sieht "Feel"
       ja bereits, es wurde also nie gescrollt und "Become" tauchte nie auf.
       Der Nachbar zieht die Reihe rechtzeitig mit. */
    var chipReihe = document.querySelector('.advk-chips');
    function chipInDenBlick(ch) {
      if (!chipReihe || chipReihe.scrollWidth <= chipReihe.clientWidth) return;
      var cr = chipReihe.getBoundingClientRect(),
          pad = parseFloat(getComputedStyle(chipReihe).paddingLeft) || 0,
          /* So viel vom uebernaechsten Chip soll mitlaufen, damit sichtbar
             bleibt, dass die Reihe weitergeht. */
          spick = 28,
          /* Der Nachbar in Laufrichtung entscheidet mit. Am Ende der Reihe gibt
             es keinen — dann zaehlt das Chip selbst. */
          rechts = ch.nextElementSibling || ch,
          links  = ch.previousElementSibling || ch,
          rr = rechts.getBoundingClientRect(),
          lr = links.getBoundingClientRect(),
          r  = ch.getBoundingClientRect(),
          ziel = null;

      /* Nach links: der linke Nachbar soll ganz zu sehen sein. */
      if (lr.left < cr.left + pad) {
        ziel = chipReihe.scrollLeft + (lr.left - cr.left) - pad;
      /* Nach rechts: der rechte Nachbar soll ganz zu sehen sein, plus ein
         Stueck des naechsten als Hinweis, dass es weitergeht. */
      } else if (rr.right > cr.right - pad) {
        var nochEins = rechts.nextElementSibling ? spick : 0;
        ziel = chipReihe.scrollLeft + (rr.right - cr.right) + pad + nochEins;
      /* Das Chip selbst darf nie angeschnitten sein. */
      } else if (r.left < cr.left + pad) {
        ziel = chipReihe.scrollLeft + (r.left - cr.left) - pad;
      } else if (r.right > cr.right - pad) {
        ziel = chipReihe.scrollLeft + (r.right - cr.right) + pad;
      }
      if (ziel === null) return;
      var max = chipReihe.scrollWidth - chipReihe.clientWidth;
      ziel = Math.max(0, Math.min(max, ziel));
      if (Math.abs(ziel - chipReihe.scrollLeft) < 1) return;
      chipReihe.scrollTo({ left: ziel, behavior: rm ? 'auto' : 'smooth' });
    }

    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        chipInDenBlick(ch);
        var i = slides.findIndex(function (sl) { return sl.dataset.g === ch.dataset.g; });
        if (i >= 0) { wahl = i; wahlAktiv = true; centerOn(i); markiere(i); }
      });
    });
    var prev = document.querySelector('.advk-sl-btn[data-dir="prev"]'),
        next = document.querySelector('.advk-sl-btn[data-dir="next"]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    /* ERGÄNZUNG gegenüber Entwurf: Tastaturbedienung */
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
    });

    /* Pointer-Drag */
    var down = false, sx = 0, sl0 = 0;
    track.addEventListener('pointerdown', function (e) {
      down = true; sx = e.clientX; sl0 = track.scrollLeft;
      track.classList.add('advk-drag');
      /* Wer selbst wischt oder zieht, übernimmt: ab dann gilt wieder die
         mittigste Kachel. */
      wahlAktiv = false;
    });
    addEventListener('pointerup', function () {
      if (down) { down = false; track.classList.remove('advk-drag'); }
    });
    track.addEventListener('pointermove', function (e) {
      if (down) track.scrollLeft = sl0 - (e.clientX - sx);
    });

    paint();
    setTimeout(paint, 300);

    /* --- Galerie im Vollbild ---------------------------------------- */
    /* Die Bahn selbst ins Element-Vollbild zu schicken haette mehrere Kacheln
       nebeneinander gezeigt — gemeint ist aber EIN Motiv. Darum ein eigener
       Betrachter, der dieselbe Rasterung benutzt: ein Bild je Blick, am Rand
       das naechste angedeutet. */
    var lb    = document.querySelector('.advk-lb'),
        lbBtn = document.querySelector('.advk-sl-full');

    if (lb && lbBtn && slides.length && typeof lb.showModal === 'function') {
      var lbTrack = lb.querySelector('.advk-lb-track'),
          lbCapB  = lb.querySelector('.advk-lb-cap b'),
          lbCapE  = lb.querySelector('.advk-lb-cap em'),
          lbZ     = lb.querySelector('.advk-lb-zaehler'),
          lbProg  = lb.querySelector('.advk-lb-prog i'),
          lbRuhe  = null,
          lbFigs  = [],
          lbJetzt = 0,
          lbAuf   = false,
          lbY     = 0;

      lbBtn.hidden = false;

      /* Die Kacheln der Galerie zeigen einen 3:4-Ausschnitt. Im Vollbild soll
         das ganze Motiv zu sehen sein, darum wird aus der Shopify-URL die
         grosse Fassung abgeleitet statt das beschnittene Bild zu strecken. */
      function grossURL(img) {
        /* data-advk-src beruecksichtigen: solange das Kachelbild noch nicht
           eingesetzt ist, sind currentSrc und src leer — der Betrachter haette
           sonst einen leeren Rahmen gezeigt. */
        var u = img.currentSrc || img.getAttribute('src') ||
                img.getAttribute('data-advk-src') || '';
        return u.replace(/([?&])width=\d+/, '$1width=1600');
      }

      slides.forEach(function (sl, i) {
        var q = sl.querySelector('img');
        var fig = document.createElement('figure');
        fig.className = 'advk-lb-fig';
        /* Rahmen mit festem Seitenverhaeltnis: haelt alle Bilder gleich hoch
           und beschneidet das Bild, damit es beim Gleiten mehr zeigen kann. */
        var rahmen = document.createElement('span');
        rahmen.className = 'advk-lb-rahmen';
        var im = document.createElement('img');
        /* Erst beim Oeffnen laden: sonst zoege die Galerie beim Seitenaufbau
           ein Dutzend grosse Bilder nach, die niemand angefordert hat. */
        im.alt = q ? q.getAttribute('alt') || '' : '';
        im.loading = 'lazy';
        im.decoding = 'async';
        rahmen.appendChild(im);
        fig.appendChild(rahmen);
        lbTrack.appendChild(fig);
        lbFigs.push({ fig: fig, img: im, quelle: q, geladen: false });
      });

      function lade(i) {
        var e = lbFigs[i];
        if (!e || e.geladen || !e.quelle) return;
        e.img.src = grossURL(e.quelle);
        e.geladen = true;
      }

      function beschrifte(i) {
        var sl = slides[i];
        if (!sl) return;
        var b = sl.querySelector('figcaption b'),
            m = sl.querySelector('figcaption em');
        if (lbCapB) lbCapB.textContent = b ? b.textContent : '';
        if (lbCapE) lbCapE.textContent = m ? m.textContent : '';
        if (lbZ) lbZ.textContent = (i + 1) + ' / ' + slides.length;
        /* Fortschritt wie unter der Galerie: nie ganz leer, am Ende voll. */
        if (lbProg) {
          var anteil = slides.length > 1 ? i / (slides.length - 1) : 1;
          lbProg.style.width = (12 + anteil * 88).toFixed(2) + '%';
        }
        var p = lb.querySelector('.advk-lb-btn[data-dir="prev"]'),
            n = lb.querySelector('.advk-lb-btn[data-dir="next"]');
        if (p) p.disabled = i <= 0;
        if (n) n.disabled = i >= slides.length - 1;
      }

      /* Nachbarn mitladen, damit beim Weiterblaettern kein Loch steht. */
      function zeige(i, sanft) {
        i = Math.min(slides.length - 1, Math.max(0, i));
        lbJetzt = i;
        lade(i); lade(i - 1); lade(i + 1);
        lbFigs[i].fig.scrollIntoView({
          behavior: (sanft && !rm) ? 'smooth' : 'auto',
          block: 'nearest', inline: 'center'
        });
        beschrifte(i);
        /* Einmal ohne Scroll-Ereignis nachziehen: beim Oeffnen und beim Sprung
           per Taste stuenden die Bilder sonst unverschoben im Rahmen. */
        requestAnimationFrame(mittigsteFigur);
        /* Beim Blaettern per Taste steht das Ziel oft schon, ohne dass die Bahn
           scrollt — dann kaeme kein Ruhe-Zeitgeber und die Beschriftung bliebe
           ausgeblendet haengen. Darum hier ausdruecklich wieder einblenden. */
        ruheAbwarten();
      }

      lbBtn.addEventListener('click', function () {
        /* Dort weitermachen, wo die Galerie steht: paint() liefert die
           hervorgehobene Kachel, wahl gilt nur solange sie aktiv ist. */
        var start = wahlAktiv ? wahl : paint();
        lb.showModal();
        lbAuf = true;
        lbY = window.scrollY || document.documentElement.scrollTop || 0;
        document.body.style.top = (-lbY) + 'px';
        document.documentElement.classList.add('advk-lb-auf');
        /* Erst nach dem Oeffnen positionieren — vorher hat der Dialog keine
           Masse und scrollIntoView liefe ins Leere. */
        requestAnimationFrame(function () { zeige(start, false); });
      });

      lb.querySelectorAll('.advk-lb-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          zeige(lbJetzt + (b.dataset.dir === 'next' ? 1 : -1), true);
        });
      });

      var lbX = lb.querySelector('.advk-lb-x');
      if (lbX) lbX.addEventListener('click', function () { lb.close(); });

      /* Klick auf den Grund schliesst — der Dialog selbst ist die Flaeche,
         die Bahn liegt darin. */
      lb.addEventListener('click', function (e) {
        if (e.target === lb) lb.close();
      });

      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); zeige(lbJetzt + 1, true); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); zeige(lbJetzt - 1, true); }
      });

      /* Wischen im Vollbild: welches Bild in der Mitte steht, sagt die
         Scrollposition — dieselbe Logik wie in der Galerie. */
      /* Sucht die mittigste Figur und verschiebt zugleich die Bilder in ihren
         Rahmen — derselbe Effekt wie in der Galerie, siehe UEBERSTAND.
         Erst alle Masse lesen, dann alle Bilder setzen: gemischt kostet jede
         Kachel ein eigenes Neuberechnen des Layouts, und das bei jedem Frame
         eines Wischers. */
      function mittigsteFigur() {
        var breite = lbTrack.clientWidth,
            c = lbTrack.getBoundingClientRect().left + breite / 2,
            best = lbJetzt, bd = 1e9,
            mitten = lbFigs.map(function (e) {
              var r = e.fig.getBoundingClientRect();
              return r.left + r.width / 2;
            });

        mitten.forEach(function (mitte, i) {
          var d = Math.abs(mitte - c);
          if (d < bd) { bd = d; best = i; }
        });

        if (!rm) {
          mitten.forEach(function (mitte, i) {
            lbFigs[i].img.style.transform =
              'translate3d(' + (((mitte - c) / breite) * -UEBERSTAND).toFixed(1) + 'px,0,0)';
          });
        }
        return best;
      }

      /* Ruhe erkennen: kommt 120 ms lang kein Scroll-Ereignis mehr, ist die
         Bahn eingerastet — dann erst wieder beschriften und einblenden. Ein
         'scrollend'-Ereignis gibt es noch nicht ueberall, darum der Zeitgeber.
         Dieselbe Wartezeit gilt fuer Wischen und Tastendruck. */
      function ruheAbwarten() {
        clearTimeout(lbRuhe);
        lbRuhe = setTimeout(function () {
          lbJetzt = mittigsteFigur();
          beschrifte(lbJetzt);
          lb.classList.remove('advk-lb-wandert');
        }, 120);
      }

      var lbT = false;
      lbTrack.addEventListener('scroll', function () {
        if (!lbAuf) return;

        /* Waehrend der Bewegung nur ausblenden und Nachbarn nachladen. Der Text
           wechselte frueher mitten im Gleiten und wirkte dadurch wie ein
           Flackern — jetzt steht er erst wieder, wenn das Bild steht. */
        if (!rm) lb.classList.add('advk-lb-wandert');
        /* Jeden Frame: Bilder verschieben (das ist der Effekt) und Nachbarn
           nachladen. Nur die Beschriftung wartet auf den Stillstand. */
        if (!lbT) {
          lbT = true;
          requestAnimationFrame(function () {
            var best = mittigsteFigur();
            if (best !== lbJetzt) { lbJetzt = best; lade(best + 1); lade(best - 1); }
            lbT = false;
          });
        }

        ruheAbwarten();
      }, { passive: true });

      /* Beim Schliessen die Galerie dorthin nachziehen, wo man im Vollbild
         stehengeblieben ist — sonst springt man aus Bild 9 zurueck auf 3. */
      /* 'close' deckt alle Wege ab — Kreuz, Klick auf den Grund und Escape. */
      lb.addEventListener('close', function () {
        lbAuf = false;
        /* Erst loesen, dann zurueckspringen: solange der Koerper festsitzt,
           laeuft ein scrollTo ins Leere. */
        document.documentElement.classList.remove('advk-lb-auf');
        document.body.style.top = '';
        window.scrollTo(0, lbY);
        wahl = lbJetzt; wahlAktiv = true;
        centerOn(lbJetzt); markiere(lbJetzt);
        lbBtn.focus();
      });
    }
  }

  /* --- Sprungmarken: weich scrollen statt springen ------------------- */
  /* scroll-behavior gehört auf das Wurzelelement. Aus einem section-scoped
     Stylesheet können wir html nicht anfassen, ohne den ganzen Shop zu
     beeinflussen — deshalb hier pro Klick, und nur wenn der Nutzer keine
     reduzierte Bewegung verlangt. Der Versatz berücksichtigt Theme-Header
     plus Sprungleiste, damit das Ziel nicht darunter verschwindet. */
  /* Auch der CTA der Sticky-Pille scrollt weich — er zeigt auf das Kaufmodul,
     das außerhalb unseres Scopes liegt und daher kein scroll-margin erbt. */
  /* Alle seiteninternen Sprunglinks in unserem Bereich weich scrollen lassen —
     Sprungleiste, Kapitelkacheln im Hero, die "Jetzt sichern"-Links der Kapitel
     und die Pille. Eine Liste einzelner Selektoren wurde jedes Mal unvollständig,
     als eine neue Verlinkung dazukam. */
  document.querySelectorAll('.advk-2026 a[href^="#"], [data-advk-nav] a[href^="#"]')
    .forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var ziel = document.querySelector(id);
      /* Fällt der Link auf das Kaufmodul, greift ein Präfix-Selektor: Shopify
         rendert id="MainProduct-template--<Nummer>__main", die Nummer steht im
         Theme-Editor nicht fest und kann im Link nicht hinterlegt werden. */
      if (!ziel && id.indexOf('#MainProduct') === 0) {
        ziel = document.querySelector('[id^="MainProduct-"]');
      }
      if (!ziel) return;                       // toter Link: Standardverhalten
      e.preventDefault();
      /* Versatz aus dem, was oben WIRKLICH stehen bleibt: ist die Hauptnavigation
         ausgeblendet, darf ihre Höhe nicht mitgerechnet werden. */
      var kopf = document.documentElement.classList.contains('advk-nav-uebernimmt')
        ? 0
        : (parseFloat(getComputedStyle(document.documentElement)
             .getPropertyValue('--header-height')) || 52);
      var leiste = 0;
      var nav = document.querySelector('.advk-nav');
      if (nav && getComputedStyle(nav).position === 'fixed') {
        leiste = nav.getBoundingClientRect().height;
      }
      var y = ziel.getBoundingClientRect().top + window.scrollY - kopf - leiste - 10;
      window.scrollTo({ top: Math.max(0, y), behavior: rm ? 'auto' : 'smooth' });
      /* Die Sprungmarke wird bewusst NICHT in die Adresse geschrieben. Sonst
         merkt sich der Browser sie und springt beim Neuladen von selbst dorthin,
         noch bevor unser Skript läuft — die Seite öffnete dann mitten im
         Überblick statt oben. */
    });
  });

  /* --- Direktaufruf mit Sprungmarke -------------------------------- */
  /* Kommt jemand mit #galerie o. ä. auf die Seite, hat der Browser schon
     gesprungen — ohne Rücksicht auf Header und Sprungleiste, das Ziel liegt
     dann darunter. Einmal nachkorrigieren, ohne Animation, damit es nicht
     wie ein zweiter Sprung wirkt. */
  if (location.hash && location.hash.length > 1) {
    var direkt = document.querySelector(location.hash);
    if (direkt) {
      requestAnimationFrame(function () {
        var kopf2 = parseFloat(getComputedStyle(document.documentElement)
                      .getPropertyValue('--header-height')) || 52;
        var nav2 = document.querySelector('.advk-nav');
        var leiste2 = nav2 ? nav2.getBoundingClientRect().height : 0;
        window.scrollTo({
          top: Math.max(0, direkt.getBoundingClientRect().top + window.scrollY - kopf2 - leiste2 - 10),
          behavior: 'auto'
        });
      });
    }
  }

  /* --- Videos ------------------------------------------------------- */
  function istVollbild(v) {
    var drin = document.fullscreenElement || document.webkitFullscreenElement;
    /* iOS meldet den nativen Player ueber ein eigenes Merkmal, nicht ueber
       document.fullscreenElement. */
    return (drin && (drin === v || drin.contains(v))) || v.webkitDisplayingFullscreen === true;
  }

  /* Quelle erst bei Sichtbarkeit setzen, damit nichts vorab geladen wird. */
  function lazyVideo(v, opts) {
    if (!v) return;
    var src = v.dataset.src;
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          if (src && !v.src) v.src = src;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});   // Autoplay-Blocker
        } else if (!v.paused && !istVollbild(v)) {
          /* Im Vollbild nicht anhalten: dort aendert sich die Geometrie, der
             Beobachter meldet "nicht sichtbar" — und wuerde das Video genau
             in dem Moment stoppen, in dem man es sehen will. */
          v.pause();
        }
      });
    }, { threshold: opts.threshold });
    o.observe(v);
  }
  lazyVideo(document.querySelector('.advk-story-bg video'), { threshold: .15 });

  var vu = document.querySelector('.advk-vfig video');
  lazyVideo(vu, { threshold: .4 });
  var sb = document.querySelector('.advk-vsound');
  if (sb && vu) {
    sb.addEventListener('click', function () {
      vu.muted = !vu.muted;
      var lab = sb.querySelector('span');
      if (lab) lab.textContent = vu.muted ? 'Ton an' : 'Ton aus';
      sb.setAttribute('aria-pressed', vu.muted ? 'false' : 'true');
      if (!vu.muted) { var p = vu.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  /* Vollbild fuers Handy. Zwei Wege, weil iPhone-Safari kein Vollbild fuer
     beliebige Elemente kennt: dort geht nur der native Player des <video>
     selbst. Wo weder das eine noch das andere existiert, bleibt die Taste
     versteckt — lieber keine Taste als eine, die nichts tut. */
  var fb = document.querySelector('.advk-vfull');
  if (fb && vu) {
    var fig = vu.closest('.advk-vfig') || vu;
    var kannElement = !!(fig.requestFullscreen || fig.webkitRequestFullscreen);
    var kannVideo   = !!vu.webkitEnterFullscreen;

    if (kannElement || kannVideo) {
      fb.hidden = false;
      fb.addEventListener('click', function () {
        var drin = document.fullscreenElement || document.webkitFullscreenElement;
        if (drin) {
          (document.exitFullscreen || document.webkitExitFullscreen).call(document);
          return;
        }
        /* Quelle kann noch fehlen, wenn jemand tippt, bevor der Beobachter
           ausgeloest hat. */
        if (!vu.src && vu.dataset.src) vu.src = vu.dataset.src;

        if (kannElement) {
          var r = (fig.requestFullscreen || fig.webkitRequestFullscreen).call(fig);
          if (r && r.catch) r.catch(function () {
            if (kannVideo) vu.webkitEnterFullscreen();
          });
        } else {
          /* Der native iOS-Player braucht ein geladenes Video. */
          if (vu.readyState >= 1) {
            vu.webkitEnterFullscreen();
          } else {
            vu.addEventListener('loadedmetadata', function () {
              vu.webkitEnterFullscreen();
            }, { once: true });
            vu.load();
          }
        }
        var p = vu.play(); if (p && p.catch) p.catch(function () {});
      });

      /* Im Vollbild ist der Ton das Erwartete, danach wieder still, damit das
         Video beim Weiterscrollen nicht in die Seite hineinredet. */
      ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (ev) {
        document.addEventListener(ev, function () {
          var drin = document.fullscreenElement || document.webkitFullscreenElement;
          if (drin !== fig && drin !== vu) {
            vu.muted = true;
            if (sb) {
              var l = sb.querySelector('span');
              if (l) l.textContent = 'Ton an';
              sb.setAttribute('aria-pressed', 'false');
            }
          }
          fb.setAttribute('aria-label',
            (drin === fig || drin === vu) ? 'Vollbild beenden' : 'Video im Vollbild zeigen');
        });
      });
    }
  }

  /* --- Gravur: Buchstabe auf dem Produktfoto ------------------------ */
  /* Der Buchstabe ist CSS-Text über einem Foto der BLANKEN Platte. Die
     Tasten baut erst dieses Skript: ohne JS soll keine Leiste dastehen,
     die man anklicken kann, aber nichts tut. */
  /* Pro Modul einmal aufsetzen, nicht nur fuer das erste: "Gravur-Modul
     zeigen" ist im Schema ein Haken pro Kapitel-Instanz. Heute hat nur
     BECOME ihn gesetzt, aber wer im Theme-Editor ein zweites Kapitel
     anhakt, bekaeme sonst eine tote Leiste ohne Fehlermeldung. */
  document.querySelectorAll('[data-advk-eng]').forEach(function (mod) {
    if (mod.hasAttribute('data-advk-eng-statisch')) return;

    var buehne = mod.querySelector('.advk-eng-brief');
    var wahl   = mod.querySelector('.advk-eng-wahl');
    var sagt   = mod.querySelector('.advk-eng-sagt');
    if (!buehne || !wahl) return;

    var ABC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    /* "D" statt "A": am Alphabetanfang steht die Scheibe am Anschlag, links
       davon ist Leerraum und es sieht aus wie ein defektes Bedienelement. Ab
       "D" liegen auf beiden Seiten Buchstaben.

       Der Rueckfall greift auch bei "A", nicht nur bei leer: im Template steht
       ein gespeichertes "A", und genau diese Datei uebernimmt Shopify nicht
       (bei .json-Templates gewinnt die Theme-Editor-Fassung). Solange das so
       ist, laesst sich "A" als Startbuchstabe nicht ueber den Theme-Editor
       erzwingen — dann muesste diese Zeile weichen. */
    var start = (mod.getAttribute('data-advk-start') || '')
                  .toUpperCase().replace(/[^A-Z]/g, '').charAt(0);
    if (!start || start === 'A') start = 'D';
    var jetzt = start;
    window.__advkBrief = jetzt;

    /* Waehlscheibe statt 26 Kaestchen: ein Alphabet-Raster liest sich als
       Konfigurator, nicht als Schmuckstueck. Die Buchstaben laufen durch eine
       Kerbe, der aktive rastet vergroessert in der Mitte ein.

       Ein einzelner Tabstop mit role="slider": fuer die Tastatur ist das ein
       Schieberegler mit 26 Rasten, nicht eine Gruppe aus 26 Knoepfen. */
    var spur = document.createElement('div');
    spur.className = 'advk-eng-spur';
    var kerbe = document.createElement('span');
    kerbe.className = 'advk-eng-kerbe';
    kerbe.setAttribute('aria-hidden', 'true');
    var band = document.createElement('div');
    band.className = 'advk-eng-band';

    var tasten = ABC.map(function (L) {
      var b = document.createElement('b');
      b.setAttribute('data-advk-brief', L);
      b.textContent = L;
      band.appendChild(b);
      return b;
    });

    spur.appendChild(kerbe);
    spur.appendChild(band);
    wahl.appendChild(spur);

    /* Hinweis, dass sich die Scheibe ziehen laesst. Vom Skript gebaut, nicht
       von Liquid: ohne JS gibt es nichts zu ziehen, dann waere der Hinweis
       eine Luege. aria-hidden, weil die Bedienung fuer Screenreader ueber
       role="slider" schon angekuendigt ist — dort ist "ziehen" irrelevant. */
    var tipp = document.createElement('div');
    tipp.className = 'advk-eng-tipp';
    tipp.setAttribute('aria-hidden', 'true');
    tipp.innerHTML = '<i>&#9664;</i><span>' +
      (mod.getAttribute('data-advk-tipp') || 'ziehen oder tippen') +
      '</span><i>&#9654;</i>';
    wahl.parentNode.insertBefore(tipp, wahl.nextSibling);

    /* Einmal bedient, Hinweis weg — und zwar dauerhaft fuer diese Ansicht. */
    function verstanden() {
      mod.classList.add('advk-verstanden');
    }

    /* Die Gruppe traegt die Bedienung, nicht die einzelnen Buchstaben. */
    wahl.setAttribute('role', 'slider');
    wahl.setAttribute('tabindex', '0');
    wahl.setAttribute('aria-valuemin', '1');
    wahl.setAttribute('aria-valuemax', String(ABC.length));
    /* Das Liquid setzt aria-label schon auf der Gruppe; nur nachziehen,
       falls es fehlt. */
    if (!wahl.getAttribute('aria-label')) {
      wahl.setAttribute('aria-label', 'Initiale wählen');
    }

    /* Breite einer Rastung: aus dem CSS lesen, damit Layout und Rechnung
       nicht auseinanderlaufen, wenn dort jemand die Breite aendert. */
    function rast() {
      var w = parseFloat(getComputedStyle(spur).getPropertyValue('--advk-rast'));
      return w > 0 ? w : 58;
    }

    function mal(fokus) {
      var i = ABC.indexOf(jetzt);
      /* Auch die Platte nachziehen: Liquid rendert dort den Wert aus dem
         Template ("A"), das Skript startet aber ggf. auf "D" — ohne das
         zeigten Foto und Scheibe verschiedene Buchstaben. */
      if (buehne.textContent !== jetzt) buehne.textContent = jetzt;
      band.style.transform = 'translateX(' + (-i * rast() - rast() / 2) + 'px)';
      tasten.forEach(function (b, n) {
        if (n === i) b.setAttribute('data-advk-an', '');
        else b.removeAttribute('data-advk-an');
      });
      wahl.setAttribute('aria-valuenow', String(i + 1));
      wahl.setAttribute('aria-valuetext', jetzt);
      if (fokus) wahl.focus();
    }

    function setze(L, fokus) {
      if (!L || ABC.indexOf(L) < 0) return;
      /* Auch ein Klick auf den schon gewaehlten Buchstaben ist eine Bedienung —
         der Nutzer hat die Scheibe verstanden, der Hinweis darf gehen. */
      verstanden();
      if (L === jetzt) { if (fokus) wahl.focus(); return; }
      jetzt = L;
      window.__advkBrief = L;
      buehne.textContent = L;
      mal(fokus);
      if (sagt) sagt.textContent = 'Gravur-Vorschau: ' + L;
      if (!rm) {
        /* Kurzes Aufblitzen, damit der Wechsel wahrnehmbar ist. Der
           Buchstabe selbst erscheint sofort — er ist Information. */
        buehne.style.opacity = '.35';
        setTimeout(function () { buehne.style.opacity = ''; }, 20);
      }
    }
    function setzeIndex(n, fokus) {
      setze(ABC[Math.max(0, Math.min(ABC.length - 1, n))], fokus);
    }
    mal(false);

    /* --- Ziehen ---------------------------------------------------- */
    /* Waehrend des Ziehens laeuft das Band ohne Uebergang mit dem Finger;
       danach wieder mit, damit es sauber in die Kerbe einrastet. */
    var zieht = false, startX = 0, startI = 0, bewegt = 0;
    spur.addEventListener('pointerdown', function (e) {
      zieht = true; bewegt = 0;
      verstanden();                 // Anfassen genuegt, auch ohne Wechsel
      startX = e.clientX; startI = ABC.indexOf(jetzt);
      band.style.transition = 'none';
      if (spur.setPointerCapture) spur.setPointerCapture(e.pointerId);
    });
    spur.addEventListener('pointermove', function (e) {
      if (!zieht) return;
      var d = startX - e.clientX;
      if (Math.abs(d) > bewegt) bewegt = Math.abs(d);
      setzeIndex(startI + Math.round(d / rast()), false);
    });
    function ausZiehen() {
      if (!zieht) return;
      zieht = false;
      band.style.transition = '';
      mal(false);
    }
    spur.addEventListener('pointerup', ausZiehen);
    spur.addEventListener('pointercancel', ausZiehen);

    /* Klick springt zu dem Buchstaben, auf den gezeigt wurde — aber nicht,
       wenn der Klick nur das Ende einer Ziehbewegung ist.

       Gerechnet wird aus dem Abstand zur Mitte, NICHT aus e.target: beim
       Zeigen liegt der Buchstabe noch woanders, und nach dem Einrasten waere
       e.target ein anderer als der angeklickte. Der Abstand in Rastungen ist
       dagegen genau der Sprung, den der Nutzer gemeint hat. */
    function springe(x) {
      var r = spur.getBoundingClientRect();
      var weg = x - (r.left + r.width / 2);
      var stufen = Math.round(weg / rast());
      if (stufen !== 0) setzeIndex(ABC.indexOf(jetzt) + stufen, false);
    }
    spur.addEventListener('click', function (e) {
      if (bewegt > 6) return;                  // war ein Ziehen
      springe(e.clientX);
    });

    /* --- Tastatur -------------------------------------------------- */
    wahl.addEventListener('keydown', function (e) {
      var i = ABC.indexOf(jetzt), k = e.key;
      if (k === 'ArrowRight' || k === 'ArrowDown') setzeIndex(i + 1, false);
      else if (k === 'ArrowLeft' || k === 'ArrowUp') setzeIndex(i - 1, false);
      else if (k === 'Home') setzeIndex(0, false);
      else if (k === 'End') setzeIndex(25, false);
      else if (k === 'PageUp') setzeIndex(i + 5, false);
      else if (k === 'PageDown') setzeIndex(i - 5, false);
      else if (/^[a-zA-Z]$/.test(k)) setze(k.toUpperCase(), false);
      else return;
      e.preventDefault();
      /* Sonst faengt ein zweites Modul auf derselben Seite denselben
         Tastendruck ebenfalls ab. */
      e.stopPropagation();
    });

    /* --- Übergabe ans Kaufmodul ------------------------------------ */
    /* Die Links im Kapitel scrollen schon per eigenem Handler weiter oben.
       Hier kommt NUR die Vorauswahl dazu — kein zweites Scrollen. */
    function uebergeben() {
      var radios = document.querySelectorAll("input[name='Gravur']");
      if (radios.length < 2) return;              // Produkt ohne Gravuroption

      /* CLICK, nicht nur change! heideman-main-product.liquid haengt einen
         CLICK-Listener an die Varianten-Inputs und feuert daraus
         'shopify-pdp-variant:changed'. Nur dieses Custom-Event loest
         handleVariantChange() im Variant-Picker aus — und erst das macht
         .letter-engraving sichtbar und hebt disabled auf. Ein change-Event
         erreicht einen click-Listener nie: die Buchstabenradios blieben
         gesperrt und auf der Bestellung landete stumm der Vorgabewert "A"
         statt der Wahl des Kunden.

         Reihenfolge bleibt zwingend: erst "Mit Gravur", DANN der Buchstabe —
         ein zu frueh gesetzter Buchstabe wird von hideAndResetEngraving()
         wieder geloescht. */
      var mit = radios[1];
      if (!mit.checked) {
        mit.checked = true;
        mit.click();
      }

      /* handleVariantChange() ist async (es holt die PDP-Tabs nach), darum
         genuegt EIN Frame nicht verlaesslich. Kurz nachfassen statt raten. */
      var versuche = 0;
      (function warten() {
        var ziel = document.querySelector(
          "input[name='properties[Letter]'][value='" + jetzt + "']");
        if (ziel && !ziel.disabled) {
          ziel.checked = true;
          ziel.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        /* Nach ~1s aufgeben: der Kunde waehlt dann im Kaufmodul selbst.
           Lieber keine Vorauswahl als eine falsche. */
        if (++versuche < 60) requestAnimationFrame(warten);
      })();
    }

    /* Nur die Links DIESES Kapitels, sonst uebergibt ein zweites Modul
       seinen Buchstaben ueber die Links des ersten mit. Fehlt der
       Kapitel-Vorfahre, bleibt es beim Dokument — dann gibt es ohnehin
       nur ein Modul. */
    var kapitel = mod.closest ? mod.closest('.advk-chapter') : null;
    (kapitel || document).querySelectorAll('a[href^="#MainProduct"]')
      .forEach(function (a) { a.addEventListener('click', uebergeben); });
  });

  /* --- Pille: Preis beim Variantenwechsel nachziehen ----------------- */
  /* Die Pille rendert ihren Preis serverseitig — beim Wechsel auf "Mit Gravur"
     blieb sie auf 139 € stehen, waehrend im Kaufmodul 149 € galt. Ein falscher
     Preis in einem Kaufelement ist ein Preisangaben-Thema, kein Schoenheits-
     fehler, darum zieht sie jetzt mit. */
  (function () {
    var daten = document.querySelector('[data-advk-varianten]');
    var preisBox = document.querySelector('[data-advk-preis]');
    if (!daten || !preisBox) return;

    var konf;
    try { konf = JSON.parse(daten.textContent); } catch (e) { return; }
    if (!konf || !konf.varianten || !konf.varianten.length) return;

    var jetztEl  = preisBox.querySelector('[data-advk-jetzt]');
    var vorherEl = preisBox.querySelector('[data-advk-vorher]');
    var sparEl   = preisBox.querySelector('[data-advk-spar]');
    var sparBetr = preisBox.querySelector('[data-advk-sparbetrag]');
    if (!jetztEl) return;

    /* Betrag in Cent -> Shop-Format. Nur die zwei Platzhalter, die Shopify
       ohne Komma-Trennung nutzt; alles andere waere geraten. */
    function geld(cent) {
      var teile = (cent / 100).toFixed(2).split('.');
      var ohneKomma = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var deutsch = ohneKomma + ',' + teile[1];
      var f = konf.format || '{{amount}} €';
      return f
        .replace(/\{\{\s*amount\s*\}\}/g, deutsch)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, ohneKomma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, deutsch)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, ohneKomma);
    }

    function finde(id) {
      for (var i = 0; i < konf.varianten.length; i++) {
        if (String(konf.varianten[i].id) === String(id)) return konf.varianten[i];
      }
      return null;
    }

    function zeigen(el, an) {
      if (!el) return;
      if (an) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    }

    function ziehNach() {
      /* Die gewaehlte Variante steht im versteckten id-Feld des Kaufmoduls
         (heideman-main-product.liquid:140) — das ist auch das Feld, das
         abgeschickt wird, also die einzige Quelle, die nie abweicht. */
      var feld = document.querySelector('[id^="MainProduct-"] input[name="id"]')
              || document.querySelector('input[name="id"]');
      if (!feld) return;
      var va = finde(feld.value);
      if (!va) return;

      jetztEl.textContent = geld(va.preis);
      var hatStreich = va.streich && va.streich > va.preis;
      if (vorherEl) {
        if (hatStreich) vorherEl.textContent = geld(va.streich);
        zeigen(vorherEl, hatStreich);
      }
      if (sparEl) {
        if (hatStreich && sparBetr) sparBetr.textContent = geld(va.streich - va.preis);
        zeigen(sparEl, hatStreich);
      }
    }

    /* Dasselbe Event, das auch das Buchstabenfeld freischaltet. Das Theme
       feuert es aus einem click-Listener auf den Varianten-Inputs. */
    document.addEventListener('shopify-pdp-variant:changed', function () {
      /* Das Theme setzt das id-Feld im selben Durchlauf; ein Frame warten,
         sonst liest man den alten Wert. */
      requestAnimationFrame(ziehNach);
    });
    ziehNach();
  })();
})();
